import React from 'react';

interface ProductsIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Productos"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Dos cajas/paquetes apilados uno sobre el otro
 * - Caja superior: más pequeña, con tapa abierta hacia arriba (como una caja de zapatos)
 * - Caja inferior: más grande, rectangular con borde sólido
 * - Ambas cajas tienen líneas internas que sugieren profundidad
 * - Estilo minimalista con líneas negras/grises según el tema
 * - Representa productos empaquetados o inventario
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const ProductsIcon: React.FC<ProductsIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 146) / 150}
      viewBox="0 0 150 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M113.636 5.03125H131.818C139.347 5.03125 145.455 11.1201 145.455 18.625V127.375C145.455 134.88 139.347 140.969 131.818 140.969H106.023C105.256 142.555 104.375 144.084 103.381 145.5H131.818C141.847 145.5 150 137.372 150 127.375V18.625C150 8.62793 141.847 0.5 131.818 0.5H59.0909C49.0625 0.5 40.9091 8.62793 40.9091 18.625V41.2812H45.4545V18.625C45.4545 11.1201 51.5625 5.03125 59.0909 5.03125H77.2727V29.9531C77.2727 33.7197 80.3125 36.75 84.0909 36.75H106.818C110.597 36.75 113.636 33.7197 113.636 29.9531V5.03125ZM109.091 5.03125V29.9531C109.091 31.1992 108.068 32.2188 106.818 32.2188H84.0909C82.8409 32.2188 81.8182 31.1992 81.8182 29.9531V5.03125H109.091ZM90.9091 127.375C90.9091 134.88 84.8011 140.969 77.2727 140.969H22.7273C15.1989 140.969 9.09091 134.88 9.09091 127.375V86.5938H90.9091V127.375ZM4.54545 85.376V127.375C4.54545 137.372 12.6989 145.5 22.7273 145.5H77.2727C87.3011 145.5 95.4545 137.372 95.4545 127.375V85.376C98.1818 83.8184 100 80.873 100 77.5312V63.9375C100 58.9248 95.9375 54.875 90.9091 54.875H9.09091C4.0625 54.875 0 58.9248 0 63.9375V77.5312C0 80.873 1.81818 83.8184 4.54545 85.376ZM90.9091 82.0625H9.09091C6.59091 82.0625 4.54545 80.0234 4.54545 77.5312V63.9375C4.54545 61.4453 6.59091 59.4062 9.09091 59.4062H90.9091C93.4091 59.4062 95.4545 61.4453 95.4545 63.9375V77.5312C95.4545 80.0234 93.4091 82.0625 90.9091 82.0625Z"
        fill="currentColor"
      />
    </svg>
  );
};

